import React, { useEffect, useState } from "react";
import SideNav from "../Sidenav";
import { useSelector } from "react-redux";
import WriteOffAdjustmentReportTable from "./WriteOffAdjustmentReportTable";

const WriteOffAdjustmentReport = () => {
  const [navData1, setNavData1] = useState("iconopen");

  var NavData1 = useSelector((state) => state.Schedule?.NavData);

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);
  return (
    <>
      <>
        <SideNav />
      </>
      <div
        className={
          (navData1 === "iconopen" && "nav_right") ||
          (navData1 === "iconclose" && "nav_right1")
        }
      >
        <div
          id="demographics"
          className="appt-block-main-bill p-b-6 m-r-0 p-r-13"
        >
          <div
            className="appt-block-main schedule-comp1"
            style={{ marginTop: 4 }}
          >
            <WriteOffAdjustmentReportTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default WriteOffAdjustmentReport;
